import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import {
  MatDialog,
} from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/core/services/v2/user.service';
import { PastHealthHistory } from '../../core/models/patient/PastHealthHostoryQuestions';
import { Patient } from '../../core/models/patient/patient';
import { PatientHealthHistory } from '../../core/models/patient/PatientHealthHistory';
import { patientHealthType } from '../../core/models/patient/patientHealthType';
import { PatientMedication } from '../../core/models/patient/patientMedication';
import { PatientService } from '../../core/services/v2/patient.service';
import {
  WindowLoaderService,
} from '../../shared/components/window-loader/window-loader.service';
declare var $: any;

@Component({
  selector: 'app-patient-health',
  templateUrl: './patient-health.component.html',
  styleUrls: ['./patient-health.component.scss']
  //encapsulation: ViewEncapsulation.None
})
export class PatientHealthComponent implements OnInit {
  @Input() patientDetails: Patient;
  @Input() editEnable: boolean;
  patientMedicationDetails: PatientMedication[];
  patientProfile: Patient;
  isParams = false;
  param: number;
  patientHealthHistories: PatientHealthHistory[];
  patientHealthTypes: patientHealthType[];
  healthHistoryQuestions: PastHealthHistory[];
  constructor(
    private patientService: PatientService,
    private userService: UserService,
    private router: ActivatedRoute,
    public dialog: MatDialog,
    private loaderService: WindowLoaderService,
    //private profileEmergencyContactInfo: ProfileEmergencyContactInfoComponent
  ) { }

  ngOnInit() {
    $(document).ready(function () {
      $('.myTab-div li a').click(function (event) {
        $('.myTab-div li a.active').removeClass('active');
        $(this).addClass('active');
        var href = $(this).attr('href');
        $('#myTabContent .tab-pane').removeClass('show active');
        $(href).addClass('show active');
      });
    });

    if (this.editEnable == undefined) {
      this.editEnable = true;
    }

    this.router.params.subscribe(
      (params: any) => {
        if (params.id) {
          this.isParams = true;
          this.param = params.id;
        }
      },
      (error) => { console.error(error); }
    );

    this.userService.getUserDetails().subscribe(
      (res) => {
        // this.user = res;
        if (this.isParams || this.patientDetails != null) {
          this.getPatientDetailsById(this.param ? this.param : this.patientDetails.id);
        } else {
          this.getPatientDetailsByUserId();
        }
      },
      (error) => { console.error(error); });
  }

  ngOnDestroy(): void { }

  getPatientDetailsById(id) {
    //id = 35178;
    this.loaderService.blockWithLoader(this.patientService.getPatientDetailsById(id)).subscribe(
      (details) => {
        this.patientProfile = null;
        this.patientProfile = details;
        this.patientProfile.photoUrl = this.patientProfile.photoUrl += '?' + Math.random();
        this.getPatientHealthHistoryData(this.patientProfile.id);
      },
      (error) => { console.error(error); }
    );
  }

  getPatientDetailsByUserId() {
    this.loaderService.blockWithLoader(this.patientService.getCurrentPatientDetails()).subscribe(
      (details) => {
        this.patientProfile = null;
        this.patientProfile = details;
        this.patientProfile.photoUrl = this.patientProfile.photoUrl += '?' + Math.random();
        this.getPatientHealthHistoryData(this.patientProfile.id);
      },
      (error) => { console.error(error); }
    );
  }

  getPatientHealthHistoryData(patientId: number) {
    this.loaderService.blockWithLoader(this.patientService.getPatientHealthHistoryData(patientId)).subscribe(
      (details) => {
        this.patientHealthHistories = details;
      },
      (error) => { console.error(error); this.loaderService.hide();  }
    );
    this.getTypeAndSubType();
    this.getHealthHistoryQuestions();
  }

  getTypeAndSubType() {
    this.loaderService.blockWithLoader(this.patientService.getHealthTypeAndSubType()).subscribe(
      (details) => {
        this.patientHealthTypes = details;
      },
      (error) => { console.error(error); this.loaderService.hide(); }
    );
  }
  getHealthHistoryQuestions() {
    this.loaderService.blockWithLoader(this.patientService.getHealthHistoryQuestions()).subscribe(
      (details) => {
        this.healthHistoryQuestions = details;
      },
      (error) => { console.error(error); this.loaderService.hide(); }
    );
  }
}
